import { useToastContext } from '@rtkwlf/fenrir-react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useDeleteIvaSchedule } from '@apis/rendall/queries/use-delete-iva-schedule';
import { getScanSchedulesQueryKey } from '@apis/rendall/queries/use-get-scanner-scan-schedules';
import { useOrganizationContext } from '@packages/legacy/organization-context';
import { TOAST_DURATION } from 'ae-constants/toast';

export const useDeleteIvaScheduleWrapper = (scannerId: string) => {
  const { t } = useTranslation('telemetryScannerConfig');
  const { addToast } = useToastContext();
  const { selectedOrganization } = useOrganizationContext();
  const queryClient = useQueryClient();

  return useDeleteIvaSchedule({
    onError: () => {
      addToast({
        appearance: 'danger',
        duration: TOAST_DURATION,
        message: t('notifications.delete.error'),
        title: t('notifications.error'),
      });
    },
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: getScanSchedulesQueryKey(selectedOrganization.id, scannerId),
      });
      addToast({
        appearance: 'success',
        duration: TOAST_DURATION,
        message: t('notifications.delete.success'),
        title: t('notifications.success'),
      });
    },
  });
};
